var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"large":"","fab":"","dark":"","bottom":"","left":"","fixed":"","color":"green","aria-label":"add drink","disabled":(_vm.defaultDrink==null)},on:{"click":_vm.addDrink}},[_c('v-icon',[_vm._v("add")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d97edc36","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/otherComponents/addDrink.vue
// module id = 331
// module chunks = 1